// extracted by mini-css-extract-plugin
export default {"layer":"OuterLayer_layer__wZ6Q+"};